import React from 'react';
import {
    Flex
} from '@chakra-ui/react';

import { FormMultiSelect } from '../FormMultiSelect';
import { FormInput } from '../FormInput';
import { FormSelect } from '../FormSelect';
import { FormRadio } from '../FormRadio';

export const CreateCoupon = ({ catalogs, coupon, onChange, selectProduct, removeProduct, isUpdate }) => {

    return (
        <>
            <FormRadio
                name="Plan Type"
                radioGroupName="pricingPlanType"
                value={coupon.pricingPlanType}
                onChange={(e) => onChange("pricingPlanType", e)}
                array={[{ id: "Subscription", name: "Subscription" }, { id: "OneTimePurchase", name: "One Time Plan" }]}
                isObject={true}
                padding="20px 0 0"
                isRequired={true}
                noOfItem={2}
                disabled={isUpdate}
            />
            <Flex>
                <FormInput
                    label="Coupon Code"
                    name="couponCode"
                    type="text"
                    inputOnChange={(e) => onChange("couponCode", e)}
                    value={coupon.couponCode}
                    formProps={{ isRequired: true, isInvalid: /[^a-zA-Z0-9]/.test(coupon.couponCode) }}
                    padding="20px 20px 0 0"
                    errorMessage="Special charater not allowed"
                    placeholder="FIRST5"
                    isDisabled={isUpdate}
                />
                <FormInput
                    label="Percentage off"
                    name="percentageOff"
                    type="number"
                    inputOnChange={(e) => onChange("percentageOff", e)}
                    value={coupon.percentageOff}
                    formProps={{ isRequired: true }}
                    padding="20px 0 0"
                    placeholder="25"
                    isDisabled={isUpdate}
                />
            </Flex>
            <Flex>
                <FormInput
                    label="Maximum Redeemption"
                    name="maxRedemption"
                    type="number"
                    inputOnChange={(e) => onChange("maxRedemption", e)}
                    value={coupon.maxRedemption}
                    formProps={{ isRequired: true }}
                    padding="20px 20px 0 0"
                    placeholder="5"
                />
                <FormInput
                    label="Coupon Expiry Date"
                    name="couponExpiryDate"
                    type="date"
                    inputOnChange={(e) => onChange("couponExpiryDate", e)}
                    value={coupon.couponExpiryDate}
                    formProps={{ isRequired: true }}
                    padding="20px 0 0"
                />
            </Flex>
            <FormMultiSelect
                options={catalogs?.map(c => c.products).flat().map(p => ({ id: p.id, productName: p.productName }))}
                selectedValues={coupon.appliesToProduct}
                selectProduct={selectProduct}
                removeProduct={removeProduct}
                displayValue={"productName"}
                showCheckbox={true}
                label="Select Product"
                padding="20px 0 0"
                disable={isUpdate}
            />
            {
                coupon.pricingPlanType === "Subscription" ?
                    <Flex>
                        <FormSelect
                            formProps={{
                                isRequired: true,
                                maxWidth: "200px",
                            }}
                            padding="20px 20px 0 0"
                            label="Duration"
                            value={coupon.duration}
                            options={[{ name: "once", value: "once" }, { name: "repeating", value: "repeating" }, { name: "forever", value: "forever" }]}
                            name="duration"
                            selectOnChange={(e) => onChange("duration", e.target.value)}
                            disabled={isUpdate}
                        />
                        {
                            coupon.duration === "repeating" ?
                                <FormInput
                                    label="Duration in months"
                                    name="durationInMonths"
                                    type="number"
                                    inputOnChange={(e) => onChange("durationInMonths", e)}
                                    value={coupon.durationInMonths}
                                    formProps={{ isRequired: true }}
                                    padding="20px 0 0"
                                    placeholder="2"
                                    isDisabled={isUpdate}
                                /> : <></>
                        }
                    </Flex> :
                    <></>
            }
        </>
    );
};

export default CreateCoupon;
